import { GenericPage } from 'types/contentful-api';

export const CITY_PAGE_FRAGMENTS = ['ContactFragment', 'GenericShelfFragment'];

export interface DKCityPage {
  loading: boolean;
  data: GenericPage | null;
}
